/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/*
 *   Tag View
 *
 *  Show a list of tag "buttons" that you can select.
 *  A list of selected tags.
 *  Tag "buttons" may contain a count if they are passed in the "tags" prop.

 *  @param {array} tags: list of tags such as: [{name, count}, ...] or ["name1", ...]
 *  @param {array} selected: List of indices into the above list that have been selected. Also allows a single integer.
 *  @param {callback} onClick: callback expecting an index into the above list for the tag selected
 */
import './TagView.scss';
import Locale from '../util/Locale';

function clickHandler(props, idx) {
    return () => {
        if (props.toggleSidebar) {
            props.toggleSidebar();
        }
        if (props.onClick) {
            props.onClick(idx);
        }
    };
}

export default function TagView(props) {
    let selected = [];
    if ('selected' in props) {
        if (props.selected.length >= 0) {
            selected = props.selected.map(val => parseInt(val, 10));
        } else {
            selected.push(parseInt(props.selected, 10)); // Accept a single integer
        }
    }
    return (
        <div className="tabview">
            <div className="tag-container">
                <div className="tag-list">
                    {props.tags &&
                        props.tags.map((tag_, idx) => {
                            const ops = selected.includes(idx) ? {primary: 'primary'} : {};
                            let tag = Locale.getText(tag_);
                            let count;
                            if (typeof tag_ !== 'string') {
                                tag = tag_.name;
                                count = tag_.count;
                            }
                            return (
                                <nsemble-button {...ops} key={idx} onClick={clickHandler(props, idx)} title={tag}>
                                    {tag && <span className="tagtext">{tag}</span>}
                                    {count && <span className="count">{count}</span>}
                                </nsemble-button>
                            );
                        })}
                </div>
            </div>
        </div>
    );
}
